// extracted by mini-css-extract-plugin
export const articleList = "PostsListing-module--article-list--24mdd";
export const date = "PostsListing-module--date--3uS0R";
export const cover = "PostsListing-module--cover--2pxcY";